import { setupFormState } from '@workwave-tidal/core/form'
import { type AdjustAddressFormValues } from './types'

const defaultLocation: uui.domain.client.Location = {
  address: '',
  geoAddress: '',
  rawLatLngAsString: '',
  source: 'MANUAL',
  status: 'OK',
  latLng: { lat: 0, lng: 0 },
  rooftopLatLng: { lat: 0, lng: 0 },
}

export const form = setupFormState<AdjustAddressFormValues, ''>('', {
  id: 'adjustAddressForm',
  initialValues: {
    newLocation: defaultLocation,
    originalLocation: defaultLocation,
    keepLocationAddress: false,
  },
})
